export const FILE_MODEL = "file";

const fileModel = {
  id: "",
  name: "",
  fileName: "",
  size: 0,
  mimeType: "application/pdf",
  collection: "",
  url: ""
};

export default fileModel;
